goog.provide('el8.appchart.actions.dcMedOrder');

goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.util.amplitude.prescriptionFormHelpers');


el8.appchart.actions.dcMedOrder = function(opts) {

    opts = opts || {};
    var item = opts.item;  // medOrder
    var menu = [];

    if (el8Globals.READ_ONLY) {
        return menu; // All menu action items currently require write access
    }

    if (!opts.chartFeed) {
        // moved to floating link in the chart feed
        menu.push({
            actionText: 'Rx: Re-Order',
            actionFn: function() {
                var order = el8.ptdata.fetchById(item.getMedOrderId());
                if (opts.amplitudeSource) {
                    el8.util.amplitude.logStartPrescription(
                        opts.amplitudeSource,
                        el8.appchart.mgr.orderForm.getPrintFormType(order)
                    );
                }
                el8.appchart.mgr.orderForm.reOrderMedOrder(order);
            }
        });
    }
    menu.push({
        actionText: 'Export to Note (HPI)',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
        }
    });
    menu.push({
        actionText: 'Export to Note (Meds)',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item});
        }
    });
    menu.push({
        actionText: 'Move to Other Med (un-merge)',
        actionFn: function() {
            el8.appchart.medsHx.main.show({
                dcMedOrderId: item.getId(),
                doMoveMerge: true
            });
        }
    });
    if (!opts.chartFeed) {
        menu.push({
            actionText: 'Write Message',
            actionFn: function() {
                el8.appshared.message.prePopulateNewMessage({
                    toDocId: item.getId()
                });
            }
        });
    }
    menu.push({
       actionText: 'Remove',
       actionFn: function() {
            el8.uiwidget.deleteConfirm("discontinue med order",
                function() {
                    el8.ptdata.dcMedOrders.deleteItem(item);
                }
            );
       }
    });

    return menu;
};
